// 1. React
import React, { useEffect, useState } from 'react';

// 2. Third-party
import { Modal, Form, Input, message } from 'antd';

// 3. Services
import { categoryGlobalFormService } from '@iso/services';

const SUCCESS_CODE = '0000';

// Add / edit a form Category (Name required, Description optional).
const CategoryModal = ({ visible, category, onCancel, onSaved }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const isEdit = !!(category && category.id);

  useEffect(() => {
    if (!visible) {
      return;
    }
    if (isEdit) {
      form.setFieldsValue({ name: category.name, description: category.description });
    } else {
      form.resetFields();
    }
  }, [visible, category, isEdit, form]);

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        setLoading(true);
        const data = {
          category_global_form: {
            name: values.name,
            description: values.description || '',
            // Categories are usable immediately; keep existing flag on edit.
            is_live: isEdit ? category.is_live : 1,
          },
          // The category service iterates global_form_id — always pass an array
          // (a missing/null value would fatal on count()).
          global_form_id: [],
        };
        categoryGlobalFormService
          .storeOrUpdate(data, isEdit ? category.id : null)
          .then((res) => {
            if (res && res.code === SUCCESS_CODE) {
              message.success(isEdit ? 'Category updated' : 'Category created');
              if (onSaved) {
                onSaved();
              }
              onCancel();
            } else {
              message.error((res && res.message) || 'Failed to save category');
            }
          })
          .catch((error) => {
            console.error('Save category error:', error);
            message.error('Failed to save category');
          })
          .finally(() => {
            setLoading(false);
          });
      })
      .catch(() => {});
  };

  return (
    <Modal
      title={isEdit ? 'Edit Category' : 'Add Category'}
      visible={visible}
      onOk={handleOk}
      onCancel={onCancel}
      okText="Save"
      confirmLoading={loading}
      maskClosable={false}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, whitespace: true, message: 'Name is required' }]}
        >
          <Input placeholder="Category name" />
        </Form.Item>
        <Form.Item name="description" label="Description (optional)">
          <Input.TextArea rows={3} placeholder="Optional description" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CategoryModal;
